module.exports = __webpack_public_path__ + "static/media/gen_bio_bur_tra.b9694d43.png";